import styled from "styled-components";

export const Container = styled.div`
    float:left; 
    width:100%; 
    position:relative;  
   
    padding: 95px 20px;  
 
`;

export const HomeFornada = styled.form`

.cadastros{
  float: left;
  width: 100%;
  padding: 1%;
  position: relative
}

.md-form.md-outline{
    margin: 5px 0!important;
}

.cadastros h1{
  font-size: 25px;
  font-weight: 300;
  text-align: center;
  line-height: 35px;
  color: #565656
}

.tab-content>.active {
    padding: 20px 10px;
    border-left: 1px #ddd solid;
    border-right:1px #ddd solid;
    border-bottom:1px #ddd solid;
}

.nav-tabs{
    font-size: 12px
}

.tabelas section{
    float: left;
    width: 50%;
    padding: 10px;
    
}

.number{ 
	float: left;
    width: 100%;
    border: 1px #dbdbdb solid;
    border-radius: 5px;
    padding: 12px;
    color: #616161;
    font-size: 15px;
    font-family: 'Open Sans',sans-serif;
    margin-top: 4px;
    
}

.number::placeholder {
  color: #757575;
  opacity: 1;
  /* font-weight: bol; */
}

.tabelas section h2{
    font-size: 14px;
    text-align: center;
    font-weight: 600
}

.tabelas section div{
    max-height: 300px;
    overflow-y: auto;
    float: left;
    width:100%;
}

.sml{
    margin: -21px 0 0 0;
    float: left;
    width: 100%;
    font-size: 11px;
}

.cadastros h1 span{
    display: block;
    font-weight: 900
}

#filtros{
    float: left;
    width: 100%;
    padding: 1% 1% 4% 1%;
    position: relative
}

.selects{
    border: 1px solid #ced4da;
    width: 100%;
    appearance: none;
    border-radius: .25rem;
    float: left;
    padding: 10px 20px;
    height:100px;
    overflow: auto
}

.btnfor{
    position: absolute;
    bottom:5%;
    right: 1%;
}

.campos20, .campos30, .campos40, .campos50, .campos60, .campos100{
    float: left;
    padding: 10px;
    position: relative;
}

.campos20{
    width: 20%;
}

.campos30{
    width: 30%;
}
.campos40{
    width: 40%;
}
.campos50{
    width: 50%;
}
.campos60{
    width: 60%;
}

.campos100{
    width: 100%;
}

#marta1, #marta2, #marta3{
    display:none
}

.visivel{
    display: block!important
}

#resultado{
    float: left;
    width: 100%;
    padding: 0 2%;
    border: 1px #ddd solid;
    border-radius: 5px;
}

.tabresp{
    float: left;
    width: 100%;

}

#infos{
    float: left;
    width: 100%;
    padding: 2% 0
}

#infos section{   
   
    float: left;
    width: 14.2%;
    text-align: center;
    font-size: 15px;
}

#infos section p{
 padding: 0 20px;
}

#infos section strong{
    color: #333;
    font-weight: 900;
    font-size: 30px;
    display: block
}



@media only screen and  (max-width: 1366px) {
 

}


@media only screen and  (max-width: 1024px) {
    
}
@media only screen and  (max-width: 801px) {

    .campos20, .campos30, .campos40, .campos50, .campos60, .campos100{
        width: 100%
    }

    .tabresp{    
        overflow-x: auto
    }

    
    #infos section{
      width: 25%;
    }
}
@media only screen and  (max-width: 668px) {

}
@media only screen and  (max-width: 480px) {

    #infos section {
      width: 33%;
  }

}

`; 